import autobind from "autobind-decorator";
import React from "react";

import { FlexLeftWrap } from "common/fragments/Flex";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { ButtonView } from "common/views/button/Button.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Organization from "./entities/Organization";
import Config from "./OrganizationSummaryConfig";

@Panel({id: "organization-summary", configClass: Config, pageParams: true})
@QueryOne(Organization, {}, true)
export default class OrganizationSummary extends React.PureComponent<IPanelProps<Config> & IQueryOne<Organization>> {

	@autobind
	public getQueryParams(): object {
		return { guid: this.props.pageParams.guid };
	}

	public render() {
		const { config, entity } = this.props;
		const { showChildren, showLogo } = config;

		const logo = showLogo && (
			<ImageView
				variant={ImageVariant.ICON}
				src={entity.logoURL}
				style={{
					height: config.logoHeight,
					width: config.logoWidth
				}}
				viewKey="logo"
			/>
		);

		const children = showChildren && entity.children && entity.children.map((c) => {
			return (
				<ButtonView onClick={() => this.setCurrentOrg(c.guid)} viewKey="child-org-button">
					{c.name}
				</ButtonView>
			);
		});

		return (
			<BlockView variant={BlockVariant.JUMBOTRON} viewKey="jumbotron">
				<FlexLeftWrap>
					{logo}
					<BlockView viewKey="details">
						<HeadingView variant={HeadingVariant.H2} viewKey="name" children={entity.name} />
						<div>
							{children}
						</div>
					</BlockView>
				</FlexLeftWrap>
			</BlockView>
		);
	}

	@autobind
	private setCurrentOrg(guid: string): void {
		this.props.actions.pushPageParam('guid', guid);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/summary/OrganizationSummary.panel.tsx